import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Optional } from 'utility-types';
import { ICustomCodeEnvironment } from '@scale/shared/types/config';
import _ from 'lodash';

export type CodeScratchpadState = {
  code: string;
  language: string;
  selectedCustomCodeEnvironment?: ICustomCodeEnvironment | null;
};

type CodingScratchpadStore = {
  scratchpadCodeState: Record<string, CodeScratchpadState>;
  setScratchpadCodeState: (storeKey: string, newState: Optional<CodeScratchpadState>) => void;
  getScratchpadCodeState: (storeKey: string) => CodeScratchpadState | null;
};

/**
 * Store for persisting code and language state for scratchpads
 */
export const useCodingScratchpadStore = create<CodingScratchpadStore>()(
  devtools((set, get) => ({
    scratchpadCodeState: {},
    setScratchpadCodeState: (storeKey: string, newState: Optional<CodeScratchpadState>) => {
      set(state => ({
        scratchpadCodeState: {
          ...state.scratchpadCodeState,
          [storeKey]: _.merge(state.scratchpadCodeState[storeKey], newState),
        },
      }));
    },
    getScratchpadCodeState: (storeKey: string) => {
      const cachedState = get().scratchpadCodeState[storeKey];
      if (!cachedState || Object.keys(cachedState).length === 0) {
        return null;
      }

      return cachedState;
    },
  })),
);
